import { styled } from '@mui/material';
import { Chip } from '@customink/pigment-react';

export const UpperCaseChip = styled(Chip)(() => ({
    textTransform: 'uppercase',
}));
